import { api } from 'utils/hooks/useApi';

export const reorderStudy = (data: any) => api().post(`/portal-api/study/reorder`, data);

export const createForReorder = (values: any): Promise<any | boolean> =>
  api().post(`/portal-api/studyRequest/createForReorder`, values);

export const editRequestForReorder = (values: any): Promise<any | boolean> =>
  api().post(`/portal-api/studyRequest/editForReorder`, values);
